import { Injectable } from '@angular/core';
import type { IPendo } from '@lib/pendo-types';
import { IPendoWindow } from '@lib/pendo-types';
import { isProduction, isAnyLocal, isStaging } from '@lib/environments.const';

declare const window: IPendoWindow;

@Injectable({ providedIn: 'root' })
export class PendoAnalytics {
  public trackEvent(name: string, attributes: object): void {
    const pendo: IPendo = window.pendo;
    if (pendo && pendo.track) {
      pendo.track(name, attributes);
    } else {
      if (
        !isProduction() &&
        !isStaging() &&
        // to avoid logging errors locally specially for the case when add blocker is installed
        !isAnyLocal()
      ) {
        console.error(
          `Submission of pendo "${name}" track event is failed. Disable ad blocker if installed and try again`,
          attributes,
        );
      }
    }
  }

  public loginAndRedirect(anchor: HTMLElement): void {
    const pendo: IPendo = window.pendo;
    pendo.feedback.loginAndRedirect({ anchor });
  }
}
